module.exports = __webpack_public_path__ + "img/timeLine-four-backups.64374e4e.png";